import { WALLET_REWARD } from './wallet'

const TICKET_PREFIX_LABELS = {
  MG: 'Mega 6/45',
  PW: 'Power 6/55',
  KN: 'Keno',
  MD: 'Max 3D',
  MP: 'Max 3D Pro',
  KT: 'Xổ số kiến thiết',
  LT: 'Lô tô',
}

const WITHDRAW_METHOD_LABELS = {
  CASH: 'tiền mặt',
  BANKING: 'chuyển khoản ngân hàng',
  GPAY: 'GPay',
  ZALOPAY: 'ZaloPay',
  MBBANK: 'MB Bank',
  APPOTAPAY: 'AppotaPay',
}

const EXACT_LABELS = {
  BUY: 'Mua vé',
  'CHARGE-MANUAL': 'Nạp tiền thủ công',
  'CHARGE-AUTO': 'Nạp tiền tự động',
  REFUND: 'Thu hồi tiền khỏi tài khoản',
  'REJECT-WITHDRAW': 'Hoàn tiền do từ chối yêu cầu rút',
  'REMOVE-TICKET-BY-ADMIN': 'Hoàn tiền vé bị quản trị huỷ',
  'REMOVE-TICKET-BY-EMPLOYEE': 'Hoàn tiền vé bị nhân viên huỷ',
  'DELETE-TICKET': 'Hoàn tiền khách tự huỷ vé',
  'REFUND-EXPIRED-PERIOD': 'Hoàn tiền kỳ đã qua giờ chốt',
  'RECONCILE-REFUND-BALANCE': 'Cân đối lại số dư ví chơi',
  'RECONCILE-REWARD-BALANCE': 'Cân đối lại số dư ví thưởng',
}

const CHARGE_SEPAY_PREFIX = 'CHARGE-SEPAY-'
const CHARGE_PREFIX = 'CHARGE-'
const WITHDRAW_INTERNAL = 'WITHDRAW-INTERNAL'
const WITHDRAW_PREFIX = 'WITHDRAW-'
const TRANSFER_TO_REWARD = 'TRANSFER-AMOUNT-REWARD'
const CASHBACK_CLASSIC_PREFIX = 'CASHBACK-CLASSIC-'
const CASHBACK_PREFIX = 'CASHBACK'
const REFUND_LOTO_CART_PREFIX = 'REFUND-LOTO-CART-'
const REFUND_LOTO_PREFIX = 'REFUND-LOTO-'
const PAY_REWARD_PREFIXES = ['KT_Reward_', 'LT_Reward_', 'Reward_']

const getGameLabel = (description) => {
  const firstId = description.split(',')[0].trim().toUpperCase()
  return TICKET_PREFIX_LABELS[firstId.slice(0, 2)] || ''
}

const getWithdrawLabel = (description) => {
  const method = description.slice(WITHDRAW_PREFIX.length)
  return `Rút tiền qua ${WITHDRAW_METHOD_LABELS[method] || method.toLowerCase()}`
}

const getLabel = (description, wallet, amount) => {
  if (EXACT_LABELS[description]) return EXACT_LABELS[description]

  if (description === WITHDRAW_INTERNAL) {
    return wallet === WALLET_REWARD ? 'Chuyển tiền thưởng sang ví chơi' : 'Nhận tiền từ ví thưởng'
  }

  if (description === TRANSFER_TO_REWARD) {
    return wallet === WALLET_REWARD ? 'Nhận tiền từ ví chơi' : 'Chuyển tiền sang ví thưởng'
  }

  if (description.startsWith(CHARGE_SEPAY_PREFIX)) return 'Nạp tiền qua chuyển khoản ngân hàng'
  if (description.startsWith(CHARGE_PREFIX)) return 'Nạp tiền'
  if (description.startsWith(WITHDRAW_PREFIX)) return getWithdrawLabel(description)
  if (description.startsWith(CASHBACK_CLASSIC_PREFIX)) return 'Hoàn tiền vé kiến thiết'
  if (description.startsWith(CASHBACK_PREFIX)) return 'Hoàn tiền vé'
  if (description.startsWith(REFUND_LOTO_CART_PREFIX)) return 'Hoàn tiền huỷ đơn Lô tô'
  if (description.startsWith(REFUND_LOTO_PREFIX)) return 'Hoàn tiền huỷ vé Lô tô'
  if (PAY_REWARD_PREFIXES.some((prefix) => description.startsWith(prefix))) return 'Trả tiền thưởng về ví chơi'

  const gameLabel = getGameLabel(description)
  if (!gameLabel) return description

  if (amount < 0) return `Mua vé ${gameLabel}`
  return wallet === WALLET_REWARD ? `Trúng thưởng ${gameLabel}` : `Trả thưởng vé ${gameLabel}`
}

export const describeMoneyLog = (description, wallet, amount) => {
  const rawDescription = (description || '').trim()
  if (!rawDescription) return { label: 'Điều chỉnh số dư', reference: '' }

  const label = getLabel(rawDescription, wallet, amount)
  return { label, reference: label === rawDescription ? '' : rawDescription }
}
